import Swal from "sweetalert2";
import { ListAllSessionsUseCase } from "../../application/usecases/list-all-sessions.usecase";
import { SessionListItem } from "../../application/domain/session-list-item";

type LoadListSessionsProps = {
    setLoad: (v: boolean) => void;
    setSessions: (sessions: SessionListItem[]) => void;
};

export class ListSessionsController {
    static async loadSessions(ui: LoadListSessionsProps): Promise<void> {
        try {
            ui.setLoad(true);
            const sessions = await ListAllSessionsUseCase.execute();
            ui.setSessions(sessions);
            ui.setLoad(false);
        } catch {
            ui.setLoad(false);
            Swal.fire({
                title: "Erro",
                text: "Erro ao listar sessões",
                icon: "error",
            });
        }
    }
}
